import { Injectable } from '@angular/core';
import {
	ActivatedRouteSnapshot,
	CanActivate,
	Router,
	RouterStateSnapshot,
	UrlTree,
} from '@angular/router';
import { AuthService } from '@mangosoft/mango-login';
import { Observable } from 'rxjs';
import { AuthenticationService } from '../Services/auth.service';

@Injectable({
	providedIn: 'root',
})
export class ModulesGuard implements CanActivate {
	constructor(
		private authService: AuthService,
		private router: Router,
		private authenticationService: AuthenticationService
	) {}
	canActivate(
		route: ActivatedRouteSnapshot,
		state: RouterStateSnapshot
	): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
		const token = this.authService.getToken() ? true : false;
		if (!token) {
			this.router.navigate(['/login']);
		}
		return token;
	}
}
